export enum GlobalStyleClasses {
  sapScrollBar = 'sapScrollBar'
}
